import React from "react"
import { TagFieldSeeker } from "@ui-seeker/core"


export default function EmailsTagField({ ...props }) {
	return <TagFieldSeeker
		disableClearable={false}
		label="Insert emails"
		{...props}
	/>
}